import React from "react";

/**
 * Download / export arrow onto a baseline (Figma "move-layer-down", 16px).
 * Used by the PNOĒ test header to export the test's raw data.
 */
const DownloadIcon = ({ size, fill }: { size?: number; fill?: string }) => {
  return (
    <svg
      width={size ?? 16}
      height={size ?? 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="move-layer-down">
        <path
          id="Icon"
          d="M14 14H2C1.73478 14 1.48043 14.1054 1.29289 14.2929C1.10536 14.4804 1 14.7348 1 15C1 15.2652 1.10536 15.5196 1.29289 15.7071C1.48043 15.8946 1.73478 16 2 16H14C14.2652 16 14.5196 15.8946 14.7071 15.7071C14.8946 15.5196 15 15.2652 15 15C15 14.7348 14.8946 14.4804 14.7071 14.2929C14.5196 14.1054 14.2652 14 14 14Z"
          fill={fill ?? "#1064DB"}
        />
        <path
          id="Icon_2"
          d="M7.293 11.707C7.48053 11.8945 7.73484 11.9998 8 11.9998C8.26516 11.9998 8.51947 11.8945 8.707 11.707L13.707 6.707C13.8025 6.61475 13.8787 6.50441 13.9311 6.3824C13.9835 6.2604 14.0111 6.12918 14.0123 5.9964C14.0134 5.86362 13.9881 5.73194 13.9378 5.60905C13.8875 5.48615 13.8133 5.3745 13.7194 5.2806C13.6255 5.18671 13.5139 5.11246 13.391 5.06218C13.2681 5.0119 13.1364 4.9866 13.0036 4.98775C12.8708 4.9889 12.7396 5.01649 12.6176 5.0689C12.4956 5.12131 12.3852 5.19749 12.293 5.293L9 8.586V1C9 0.734784 8.89464 0.48043 8.70711 0.292893C8.51957 0.105357 8.26522 0 8 0C7.73478 0 7.48043 0.105357 7.29289 0.292893C7.10536 0.48043 7 0.734784 7 1V8.586L3.707 5.293C3.5184 5.11084 3.2658 5.01005 3.0036 5.01233C2.7414 5.0146 2.49059 5.11977 2.30518 5.30518C2.11977 5.49059 2.0146 5.7414 2.01233 6.0036C2.01005 6.2658 2.11084 6.5184 2.293 6.707L7.293 11.707Z"
          fill={fill ?? "#1064DB"}
        />
      </g>
    </svg>
  );
};

export default DownloadIcon;
